import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import Menu from './components/Menu/Menu';
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Skills from "./pages/Skills/Skills";
import Projects from "./pages/Projects/Projects";
import CV from "./pages/CV/CV";
import Contact from "./pages/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Gallery from "./pages/Gallery/Gallery";
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();

  return (
    <>
      <Home />
      <About onPageChange={(p) => navigate(`/${p}`)} />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

function CVPage() {
  const navigate = useNavigate();

  return (
    <>
      <CV onPageChange={(p) => navigate(p === 'home' ? '/' : `/${p}`)} />
      <Footer />
    </>
  );
}

function GalleryPage() {
  const navigate = useNavigate();

  return (
    <Gallery onPageChange={(p) => navigate(p === 'home' ? '/' : `/${p}`)} />
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Menu />
              <HomePage />
              <Analytics />
            </>
          }
        />
        <Route
          path="/cv"
          element={
            <>
              <Menu />
              <CVPage />
              <Analytics />
            </>
          }
        />
        <Route
          path="/gallery"
          element={
            <>
              <Menu currentPage="gallery" />
              <GalleryPage />
              <Analytics />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
